import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: ''
    });
  };
  return <div className="w-full" data-id="element-285">
      {/* Hero Section */}
      <section className="bg-[#0a2e4a] text-white py-16" data-id="element-286">
        <div className="container mx-auto px-4" data-id="element-287">
          <div className="max-w-3xl mx-auto text-center" data-id="element-288">
            <h1 className="text-4xl font-bold mb-6" data-id="element-289">Contact Us</h1>
            <p className="text-xl" data-id="element-290">
              Your trusted appliance repair experts across the UK
            </p>
          </div>
        </div>
      </section>
      {/* Contact Info Section */}
      <section className="py-16" data-id="element-291">
        <div className="container mx-auto px-4" data-id="element-292">
          <div className="max-w-5xl mx-auto" data-id="element-293">
            <div className="text-center mb-12" data-id="element-294">
              <h2 className="text-3xl font-bold text-[#0a2e4a] mb-6" data-id="element-295">
                Get In Touch
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-296">
                We're here to help with all your appliance repair needs. Contact
                us easily via our simple form, email, or by calling our friendly
                customer support team.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-297">
              <div className="bg-white p-8 rounded-lg shadow-md text-center" data-id="element-298">
                <div className="w-16 h-16 bg-[#e6f4fa] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-299">
                  <Phone className="text-[#0a2e4a]" size={28} data-id="element-300" />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-[#0a2e4a]" data-id="element-301">
                  Call Us
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-302">
                  Our customer service team is ready to assist you.
                </p>
                <a href="tel:08000554969" className="text-[#f05a28] font-semibold text-lg hover:underline" data-id="element-303">
                  0800 055 4969
                </a>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md text-center" data-id="element-304">
                <div className="w-16 h-16 bg-[#e6f4fa] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-305">
                  <Mail className="text-[#0a2e4a]" size={28} data-id="element-306" />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-[#0a2e4a]" data-id="element-307">
                  Email Us
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-308">
                  Send us an email and we'll get back to you promptly.
                </p>
                <a href="mailto:sunitalimbu9596@gmail.com" className="text-[#f05a28] font-semibold text-lg hover:underline" data-id="element-309">
                  sunitalimbu9596@gmail.com
                </a>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md text-center" data-id="element-310">
                <div className="w-16 h-16 bg-[#e6f4fa] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-311">
                  <MapPin className="text-[#0a2e4a]" size={28} data-id="element-312" />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-[#0a2e4a]" data-id="element-313">
                  Visit Us
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-314">Our business address:</p>
                <address className="text-[#f05a28] font-semibold text-lg not-italic" data-id="element-315">
                  22 Leith Walk, Edinburgh EH6 5AA
                </address>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-316">
              {/* Contact Form */}
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-317">
                <h3 className="text-2xl font-bold text-[#0a2e4a] mb-6" data-id="element-318">
                  Send Us a Message
                </h3>
                {isSubmitted ? <div className="bg-green-50 border-l-4 border-green-500 p-4 mb-6" data-id="element-319">
                    <p className="text-green-700" data-id="element-320">
                      Thank you for your message! We'll get back to you shortly.
                    </p>
                  </div> : null}
                <form onSubmit={handleSubmit} data-id="element-321">
                  <div className="mb-4" data-id="element-322">
                    <label htmlFor="name" className="block text-gray-700 font-medium mb-2" data-id="element-323">
                      Your Name
                    </label>
                    <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0a2e4a]" required data-id="element-324" />
                  </div>
                  <div className="mb-4" data-id="element-325">
                    <label htmlFor="email" className="block text-gray-700 font-medium mb-2" data-id="element-326">
                      Email Address
                    </label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0a2e4a]" required data-id="element-327" />
                  </div>
                  <div className="mb-4" data-id="element-328">
                    <label htmlFor="phone" className="block text-gray-700 font-medium mb-2" data-id="element-329">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0a2e4a]" required data-id="element-330" />
                  </div>
                  <div className="mb-6" data-id="element-331">
                    <label htmlFor="message" className="block text-gray-700 font-medium mb-2" data-id="element-332">
                      Your Message
                    </label>
                    <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0a2e4a]" required data-id="element-333"></textarea>
                  </div>
                  <button type="submit" className="bg-[#0a2e4a] text-white px-6 py-3 rounded-md font-semibold flex items-center justify-center hover:bg-[#164875] transition w-full" data-id="element-334">
                    Send Message <Send size={18} className="ml-2" data-id="element-335" />
                  </button>
                </form>
              </div>
              {/* Business Hours */}
              <div data-id="element-336">
                <div className="bg-white p-8 rounded-lg shadow-md mb-8" data-id="element-337">
                  <h3 className="text-2xl font-bold text-[#0a2e4a] mb-6" data-id="element-338">
                    Business Hours
                  </h3>
                  <ul className="space-y-4" data-id="element-339">
                    <li className="flex justify-between items-center pb-2 border-b border-gray-100" data-id="element-340">
                      <span className="font-medium" data-id="element-341">Monday:</span>
                      <span data-id="element-342">9:00am – 5:00pm</span>
                    </li>
                    <li className="flex justify-between items-center pb-2 border-b border-gray-100" data-id="element-343">
                      <span className="font-medium" data-id="element-344">Tuesday:</span>
                      <span data-id="element-345">9:00am – 5:00pm</span>
                    </li>
                    <li className="flex justify-between items-center pb-2 border-b border-gray-100" data-id="element-346">
                      <span className="font-medium" data-id="element-347">Wednesday:</span>
                      <span data-id="element-348">9:00am – 5:00pm</span>
                    </li>
                    <li className="flex justify-between items-center pb-2 border-b border-gray-100" data-id="element-349">
                      <span className="font-medium" data-id="element-350">Thursday:</span>
                      <span data-id="element-351">9:00am – 5:00pm</span>
                    </li>
                    <li className="flex justify-between items-center pb-2 border-b border-gray-100" data-id="element-352">
                      <span className="font-medium" data-id="element-353">Friday:</span>
                      <span data-id="element-354">9:00am – 5:00pm</span>
                    </li>
                    <li className="flex justify-between items-center pb-2 border-b border-gray-100" data-id="element-355">
                      <span className="font-medium" data-id="element-356">Saturday:</span>
                      <span data-id="element-357">Closed</span>
                    </li>
                    <li className="flex justify-between items-center" data-id="element-358">
                      <span className="font-medium" data-id="element-359">Sunday:</span>
                      <span data-id="element-360">Closed</span>
                    </li>
                  </ul>
                </div>
                <div className="bg-[#e6f4fa] p-8 rounded-lg" data-id="element-361">
                  <h3 className="text-2xl font-bold text-[#0a2e4a] mb-4" data-id="element-362">
                    Our Commitment
                  </h3>
                  <p className="text-gray-600 mb-4" data-id="element-363">
                    At Peakwave, we're committed to delivering high-quality
                    repairs, transparent pricing, and outstanding customer
                    service. We understand how crucial your appliances are to
                    your daily life, so we prioritise prompt responses, clear
                    communication, and dependable support at every stage.
                  </p>
                  <p className="text-gray-600" data-id="element-364">
                    We're here to keep your appliances running smoothly—so you
                    can relax knowing your home is in expert hands.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default Contact;